import { useFormatPrice } from '../../hooks';
import { Text, type TypographyType } from '../../typography';

export type FormatPrice = {
  currency?: string;
  maximumFractionDigits?: number;
  minimumFractionDigits?: number;
  value: number;
};

export type PricesProperties = {
  currency?: 'EUR' | 'USD';
  currentPrice: number;
  isFree?: boolean;
  label?: string;
  originalPrice?: number;
  textType?: TypographyType;
};

type P = {
  prices: PricesProperties;
};

const DataCardPrice = ({ prices: { currency, currentPrice, isFree, label, originalPrice, textType = 'title' } }: P) => {
  const formatPrice = useFormatPrice();

  return (
    <>
      {isFree ? (
        // eslint-disable-next-line sonarjs/no-nested-conditional -- TODO: fix later
        currentPrice > 0 ? (
          <>
            <Text className="channels-card-price__price" type={textType} weight="bold">
              Free
            </Text>
            <Text delete type="secondary">
              {formatPrice({ currency, value: currentPrice })}
            </Text>
          </>
        ) : (
          <Text type={textType} weight="bold">
            Free
          </Text>
        )
      ) : (
        <Text className="channels-card-price__price" type={textType} weight="bold">
          {formatPrice({ currency, value: currentPrice })}
        </Text>
      )}

      {originalPrice ? (
        <Text delete size="small" type="secondary">
          {formatPrice({ currency, value: originalPrice })}
        </Text>
      ) : null}
      {label ? (
        <Text size="small" type="secondary">
          {label}
        </Text>
      ) : null}
    </>
  );
};

export default DataCardPrice;
